import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslationService } from '../__translate/translation.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerModalComponent } from 'src/app/___COMPONENTS/__common/spinner-modal/spinner-modal.component';
import { CustomSnackbarComponent } from 'src/app/___COMPONENTS/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class GuiFlowService {

  clientProfileMenuItems = [
    {
      tab: 'About',
      class: 'nav-link',
      ref: '#about',
      visible: null
    },
    {
      tab: 'Edit Profile',
      class: 'nav-link',
      ref: '#edit',
      visible: null
    },
    {
      tab: 'Create Profile',
      class: 'nav-link',
      ref: '#create',
      visible: null
    },
    {
      tab: 'User process',
      class: 'nav-link',
      ref: '#process',
      visible: null
    },
    {
      tab: 'WebApp Apps',
      class: 'nav-link',
      ref: '#apps',
      visible: null
    },
    {
      tab: 'Config',
      class: 'nav-link',
      ref: '#config',
      visible: null
    },
    {
      tab: 'Timeline',
      class: 'nav-link',
      ref: '#timeline',
      visible: null
    },
    {
      tab: 'Files',
      class: 'nav-link',
      ref: '#files',
      visible: null
    },
    {
      tab: 'Gallery',
      class: 'nav-link',
      ref: '#gallery',
      visible: null
    },
    {
      tab: 'Friends',
      class: 'nav-link',
      ref: '#friends',
      visible: null
    },
    {
      tab: 'Logs',
      class: 'nav-link',
      ref: '#logs',
      visible: true
    }
  ];
  dialogRef;

  pageFLow = {
    currentState: 'read',
    crudObject: ''
  };

  constructor(private _snackBar: MatSnackBar,private _bottomSheet: MatBottomSheet,private translationService: TranslationService,private router: Router,public dialog: MatDialog) { }

  // ---------------------------
  // SNACKBAR AND ALERTS

openSimpleSnackBar(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration?: number,action: string = 'Ok') {
    const effectiveDuration = duration !== null ? duration : 4000;
    this._snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { message, type,action,duration:effectiveDuration },
      duration:effectiveDuration,
      panelClass: ['no-padding'], // Para eliminar padding por defecto,
    });
  }

  reportSuccess(msg){
    this.openSimpleSnackBar(msg,'success');
  }

  reportError(error,trace){
    if(error && error.KO && error.KO.message){
      this.openSimpleSnackBar(error.KO.message,'error');
    }else{
      if(error){
        if(error.error){
            this.openSimpleSnackBar(error.error,'error');
        }else{
          this.openSimpleSnackBar(error,'error');
        }
      }else{
        this.openSimpleSnackBar('❌ '+'Error: check console for details','error');
      }
    }
    trace? console.log('BACKEND Error:' +trace) : console.log(error);
  }

  getClientProfileMenuItems(){
    return this.clientProfileMenuItems;
  }

  // ROUTES
  goToPage(url){
    this.router.navigateByUrl(url);
  }

  goBack() {
    window.history.back();
  }

  //
  openLoadingModal(){
    this.dialogRef = this.dialog.open(SpinnerModalComponent);

    this.dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  
  closeLoadingModal(): void {
    this.dialogRef.close();
  }

  setCurrentState(newState: string) {
    this.pageFLow.currentState = newState;
  }
}
